export class Employee {
    uid: string;
    name: string;
    email: string;
    password: string;
    job: string;
    phone: string;
    companyUID: string;
    isUser: boolean;
    photoURL: string;
    isCompanyAdmin: boolean;
}



// WEBPACK FOOTER //
// ./src/app/model/employee.ts